var youbora = require('youboralib')
var manifest = require('../manifest.json')

youbora.adapters.Yospace = youbora.Adapter.extend({

  constructor: function (sessMgr, videoContainer) {
    this.videoContainer = videoContainer
    youbora.adapters.Yospace.__super__.constructor.call(this, sessMgr)
    this.tag = videoContainer
  },

  /** Override to return current plugin version */
  getVersion: function () {
    return manifest.version + '-' + manifest.name + '-' + manifest.tech
  },

  /** Override to return current playhead of the video */
  getPlayhead: function () {
    var ret = 0
    if (this.initialPlayhead) {
      ret = this.plugin.getAdapter().getPlayhead() - this.initialPlayhead
    }
    return ret
  },

  /** Override to return video duration */
  getDuration: function () {
    var ret = null
    if (this.getAdvert()) {
      ret = this.getAdvert().linear.duration
    }
    return ret
  },

  /** Override to return current bitrate */
  getBitrate: function () {
    var ret = null
    try {
      if (this.getAdvert()) {
        ret = this.getAdvert().linear.mediaFiles[0].bitrate
      }
    } catch (err) {
      youbora.Log.notice('Can\'t get ad bitrate')
    }
    return ret
  },

  /** Override to return title */
  getTitle: function () {
    var ret = null
    if (this.getAdvert()) {
      ret = this.getAdvert().AdTitle
    }
    return ret
  },

  /** Override to return resource URL. */
  getResource: function () {
    var ret = null
    try {
      if (this.getAdvert()) {
        ret = this.getAdvert().linear.mediaFiles[0].src
      }
    } catch (err) {
      youbora.Log.notice('Can\'t get ad resource')
    }
    return ret
  },

  /** Override to return player version */
  getPlayerVersion: function () {
    return this.player.getVersion()
  },

  /** Override to return player's name */
  getPlayerName: function () {
    return 'Yospace'
  },

  getPosition: function () {
    var ret = youbora.Constants.AdPosition.Preroll
    if (this.plugin.getAdapter().flags.isJoined) {
      ret = youbora.Constants.AdPosition.Midroll
    }
    return ret
  },

  /** Override to return the number of ads given for the break (only ads) */
  getGivenAds: function () {
    var ret = 1
    if (this.actualBreak && this.actualBreak.adverts) {
      ret = this.actualBreak.adverts.length
    }
    return ret
  },

  /** Override to return the ad creative id (only ads) */
  getCreativeId: function () {
    var ret = null
    if (this.getAdvert()) {
      ret = this.getAdvert().linear.CreativeId
    }
    return ret
  },

  getAdvert: function () {
    var advert = null
    if (this.actualBreak) {
      if (this.actualBreak.advert) {
        advert = this.actualBreak.advert
      } else if (this.actualBreak.adverts) {
        advert = this.actualBreak.adverts[0].advert
      }
    }
    return advert
  },

  getIsFullscreen: function () {
    var ret = false
    if (this.videoContainer && this.videoContainer.clientWidth && this.videoContainer.clientHeight) {
      ret = (window.innerHeight <= this.videoContainer.clientHeight + 30 && window.innerWidth <= this.videoContainer.clientWidth + 30)
    }
    return ret
  },

  getIsSkippable: function () {
    return false
  },

  getAudioEnabled: function () {
    var ret = true
    if (this.videoContainer) {
      ret = !this.videoContainer.muted
    }
    return ret
  },

  getIsVisible: function () {
    var ret = true
    if (this.videoContainer) {
      ret = youbora.Util.calculateAdViewability(this.videoContainer)
    }
    return ret
  },

  /** Register listeners to this.player. */
  registerListeners: function (e) {
    youbora.Log.error(e)
    // Enable playhead monitor (buffer = true, seek = false)
    this.monitorPlayhead(true, false)

    this.player.registerPlayer({
      AdBreakStart: this.breakStart.bind(this),
      AdvertStart: this.advertStart.bind(this),
      AdvertEnd: this.advertEnd.bind(this),
      AdBreakEnd: this.breakEnd.bind(this)
    })

    this.references = {
      pause: this.pauseListener.bind(this),
      playing: this.resumeListener.bind(this)
    }
    for (var key in this.references) {
      this.videoContainer.addEventListener(key, this.references[key])
    }
  },

  /** Unregister listeners to this.player. */
  unregisterListeners: function () {
    // Disable playhead monitoring
    if (this.monitor) this.monitor.stop()

    if (this.videoContainer && this.references) {
      for (var key in this.references) {
        this.videoContainer.removeEventListener(key, this.references[key])
        delete this.references[key]
      }
    }
  },

  pauseListener: function (e) {
    this.firePause()
  },

  resumeListener: function (e) {
    this.fireResume()
  },

  breakStart: function (e) {
    this.actualBreak = e
    this.fireBreakStart()
    this.fireInit()
  },

  advertStart: function (e) {
    this.fireStart()
    this.fireJoin()
    this.initialPlayhead = this.plugin.getAdapter().getPlayhead()
    this._quartileTimer = new youbora.Timer(this.sendQuartile.bind(this), 1000)
    if (this._quartileTimer) this._quartileTimer.start()
  },

  sendQuartile: function (e) {
    var playhead = this.getPlayhead()
    var duration = this.getDuration()
    if (playhead > duration / 4) {
      this.fireQuartile(1)
      if (playhead > duration / 2) {
        this.fireQuartile(2)
        if (playhead > duration * 0.75) {
          this.fireQuartile(3)
          if (this._quartileTimer) this._quartileTimer.stop()
        }
      }
    }
  },

  breakEnd: function (e) {
    this.fireBreakStop()
  },

  advertEnd: function (e) {
    this.fireStop()
    if (this._quartileTimer) this._quartileTimer.stop()
    this.initialPlayhead = null
  }
})

module.exports = youbora.adapters.Yospace
